import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year2/Summer/PositionAndDirection/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PositionAndDirection',
  field: 'Geometry',
  weeks: [9, 10],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/1LanguageOfPosition" */ './1LanguageOfPosition'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/2DescribeMovement" */ './2DescribeMovement'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/3DescribeTurns" */ './3DescribeTurns'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/4DescribeMovementAndTurns" */ './4DescribeMovementAndTurns'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/5ShapePatternsWithTurns" */ './5ShapePatternsWithTurns'
        )
    })
  ]
});
export default Block;
